import { useDecodedToken } from './authorization.hook';
import { useBuildVars } from '../config/build-config/useBuildConfig';

export function useIsAuthorized() {
  const { appId } = useBuildVars();
  const token = useDecodedToken();
  if (appId === 'x4ec') {
    if (token?.resellerId) {
      return true;
    } else if (token?.imoProfile) {
      return false;
    }
    return undefined;
  }
  return !!token;
}
